/**
 * Created by nanhuijuan on 2019/12/17
 */
import { getCookie } from './common';
import * as Sentry from '@sentry/nextjs';


function parseJSON(response) {
  return response.json();
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}

/**
 *
 * @param data {meta: {code: 200, message: "OK"}, data: {...}}
 * @returns {*}
 */
function checkMeta(data) {
  if (!data || !data.meta) {
    throw new Error('no meta data');
  } else {
    const { meta, ...d } = data;
    if (!String(meta.code).startsWith('2')) {
      throw new Error(meta);
    } else {
      return d;
    }
  }
}

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
export default function request(url, options) {
  if (!options) {
    options = {};
  }

  return fetch(url, { ...options, credentials: 'include' })
    .then(checkStatus)
    .then(parseJSON)
    .then(checkMeta);
}

export function post(url, data) {
  return request(url, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  });
}


export function postApi(url, data, headers = {}) {
  return fetch(url,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        ...headers,
      },
      body: JSON.stringify(data),
    })
    .then((res) => res.json());
}

export function deleteApi(url, data, headers = {}) {
  return fetch(url,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        ...headers,
      },
      body: JSON.stringify(data),
    })
    .then((res) => res.json());
}


export function put(url, data) {
  const option = {
    method: 'PUT',
  };

  if (data) {
    option.body = JSON.stringify(data);
    option.headers = {
      'Content-Type': 'application/json',
    };
  }
  return request(url, option);
}

export function del(url, data) {
  const option = {
    method: 'DELETE',
  };

  if (data) {
    option.body = JSON.stringify(data);
    option.headers = {
      'Content-Type': 'application/json',
    };
  }
  return request(url, option);
}

export function get(url) {
  return request(url);
}

export function download(url, options) {
  let filename = '';
  if (!options) {
    options = {};
  }

  return fetch(url, { ...options, headers: { Accept: 'application/octet-stream' } })
    .then(checkStatus)
    .then((resp) => {
      filename = resp.headers.get('content-disposition');
      filename = filename.match(/filename="(.+?)"/)[1];
      return resp.blob();
    })
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();
      a.remove();
    });
}

export async function getWithAuth(url, headers = {}) {
  const accessToken = getCookie('access-token'); // 拿到用户的token
  return fetch(url,
    {
      method: 'GET',
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json; charset=utf-8',
      },
    }).then((res) => res.json())
    .then((result) => {
      return result;
    }).catch((err) => {
    });
}


export function postWithAuth(url, data, headers = {}) {
  const accessToken = getCookie('access-token'); // 拿到用户的token
  return fetch(url,
    {
      method: 'POST',
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify(data),
    }).then((res) => res.json())
    .then((result) => {
      if (!String(result?.code || result?.meta?.code).startsWith('2')) {
        Sentry.captureException(new Error(`postWithAuth API Error: ${JSON.stringify(result)}; url: ${url}; data:${JSON.stringify(data)}`));
      }
      return result;
    }).catch((e) => {
      Sentry.captureException(e);
    });
}

export function patchWithAuth(url, data, headers = {}) {
  const accessToken = getCookie('access-token'); // 拿到用户的token
  return fetch(url,
    {
      method: 'PATCH',
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify(data),
    }).then((res) => res.json())
    .then((result) => {
      if (!String(result?.code || result?.meta?.code).startsWith('2')) {
        Sentry.captureException(new Error(`postWithAuth API Error: ${JSON.stringify(result)}; url: ${url}; data:${JSON.stringify(data)}`));
      }
      return result;
    }).catch((e) => {
      Sentry.captureException(e);
    });
}

export function putWithAuth(url, data, headers = {}) {
  const accessToken = getCookie('access-token'); // 拿到用户的token
  return fetch(url,
    {
      method: 'PUT',
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify(data),
    }).then((res) => res.json())
    .then((result) => {
      if (!String(result?.code || result?.meta?.code).startsWith('2')) {
        Sentry.captureException(new Error(`postWithAuth API Error: ${JSON.stringify(result)}; url: ${url}; data:${JSON.stringify(data)}`));
      }
      return result;
    }).catch((e) => {
      Sentry.captureException(e);
    });
}
